import React from 'react';

const Footer = () =>{
    return(
        <div>
            <footer className=" footer pv4 ph3 ph5-m ph6-l">
               <small className="foottext f6 db tc">© 2020 <b>Chez Inc.</b>., All Rights Reserved</small>
            </footer>
        </div>
    )
}





export default Footer